import { AxiosResponse } from 'axios';
import { HOTEL_AI_URL } from '../../../../config';
import reservationAxios from '../../../../utils/axios/reservation.axios';
import { PaginatedAgentActivities } from '../../../../interfaces/agent-activitites/paginatedStore.type';

const tryToFetchActivities = (
    pageNumber: number,
    pageSize: number,
    data?: any,
): Promise<AxiosResponse<PaginatedAgentActivities>> => {
    const url = `${HOTEL_AI_URL}/ai-agents-logs?page=${pageNumber}&size=${pageSize}`;
    return reservationAxios.put<PaginatedAgentActivities>(url, data)
}

const tryToFetchLogsStats = (data?: any): Promise<AxiosResponse<any>> => {
    const url = `${HOTEL_AI_URL}/ai-agents-logs/analytics`;
    return reservationAxios.put<any>(url, data?.data)
}

const tryToFetchSingleActivity = (id: string): Promise<AxiosResponse<any>> => {
    return reservationAxios.get<any>(`${HOTEL_AI_URL}/ai-agents-logs/${id}`);
};

const tryToFetchInsights = (data?: any): Promise<AxiosResponse<any>> => {
    const url = `${HOTEL_AI_URL}/hotel-invoice-analyse/insights`;
    return reservationAxios.put<any>(url, data)
}


export const AgentActivitiesService = {
    tryToFetchActivities,
    tryToFetchLogsStats,
    tryToFetchSingleActivity,
    tryToFetchInsights
}